import { useState, useEffect } from "react";

import { useAuthState } from "react-firebase-hooks/auth";
import { auth, db } from "../../util/firebase";
import { query, collection, getDocs, where } from "firebase/firestore";

import { useNavigate } from "react-router-dom";

import classnames from "classnames";

import { ScrollMenu } from "react-horizontal-scrolling-menu";
import "react-horizontal-scrolling-menu/dist/styles.css";

import "rsuite/dist/rsuite.min.css";
import { Accordion, Panel } from "rsuite";

import BarLoader from "react-spinners/BarLoader";
import { Button } from "reactstrap";

import { useTranslation } from "react-i18next";
import PlayTutorialModal from "../../components/modals/PlayTutorialModal";
import { IoIosInformationCircleOutline } from "react-icons/io";

// import {FaChevronLeft} from 'react-icons/fa';

function PlayPage() {
  const { t, i18n } = useTranslation("common");

  const [user] = useAuthState(auth);

  // NEW MEMBERSHIP BASED BADGES
  const [activeMembershipTier, setActiveMembershipTier] = useState();
  const [activeMembershipExpiryDate, setActiveMembershipExpiryDate] =
    useState();
  const [activeMembershipTimeRemaining, setActiveMembershipTimeRemaining] =
    useState();
  //

  const fetchActiveTicketBoost = async () => {
    try {
      setIsLoading(true);

      const q = query(collection(db, "users"), where("uid", "==", user?.uid));
      const doc = await getDocs(q);
      const data = doc.docs[0].data();

      // NEW MEMBERSHIP BASED BADGES
      setActiveMembershipTier(data.membershipTier);
      setActiveMembershipExpiryDate(data.membershipExpiryDate);
      //

      // if (data.ticketBoostExpirationDatetime) {
      //   const expirationDate = data.ticketBoostExpirationDatetime.toDate();
      //   const now = new Date();
      //   const millisecondsRemaining = expirationDate - now;

      //   if (millisecondsRemaining > 0) {
      //     // Calculate remaining time for display
      //     const totalMinutes = Math.floor(millisecondsRemaining / (1000 * 60));
      //     const days = Math.floor(totalMinutes / (60 * 24));
      //     const hours = Math.floor((totalMinutes % (60 * 24)) / 60);
      //     const minutes = totalMinutes % 60;

      //     const remainingTime = `${days}d ${hours}h ${minutes}m`;
      //     setActiveTicketBoostTimeRemaining(remainingTime);

      //     // Compare expiration date to 3-month and 6-month marks
      //     const threeMonthsFromNow = new Date(now);
      //     threeMonthsFromNow.setMonth(now.getMonth() + 3);

      //     const sixMonthsFromNow = new Date(now);
      //     sixMonthsFromNow.setMonth(now.getMonth() + 6);

      //     if (expirationDate < threeMonthsFromNow) {
      //       setActiveTicketBoostIcon(
      //         "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fproducts%2FticketBoosts%2F3m.png?alt=media&token=11146845-ef4d-4328-a250-eccaa5d7fa58"
      //       );
      //     } else if (expirationDate < sixMonthsFromNow) {
      //       setActiveTicketBoostIcon(
      //         "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fproducts%2FticketBoosts%2F6m.png?alt=media&token=b3e46033-4ea0-4244-a769-dd55915402c7"
      //       );
      //     } else {
      //       setActiveTicketBoostIcon(
      //         "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fproducts%2FticketBoosts%2F12M.png?alt=media&token=35f7e11c-4f82-48a4-b9f6-f64eb70aaa97"
      //       );
      //     }
      //   } else {
      //     setActiveTicketBoostTimeRemaining("Expired");
      //     setActiveTicketBoostIcon(null);
      //   }
      // }

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occurred while fetching user data");
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (user) {
      fetchActiveTicketBoost();
    }
    // eslint-disable-next-line
  }, [user]);

  // Update countdown for active membership expiry
  useEffect(() => {
    let intervalId;

    const computeAndSet = () => {
      if (!activeMembershipExpiryDate) {
        setActiveMembershipTimeRemaining(null);
        return;
      }
      // activeMembershipExpiryDate is a Firestore Timestamp
      const expiry =
        typeof activeMembershipExpiryDate.toDate === "function"
          ? activeMembershipExpiryDate.toDate()
          : new Date(activeMembershipExpiryDate);
      const ms = expiry.getTime() - Date.now();
      if (ms <= 0) {
        setActiveMembershipTimeRemaining(t("expired"));
        return;
      }
      const totalMinutes = Math.floor(ms / (1000 * 60));
      const days = Math.floor(totalMinutes / (60 * 24));
      const hours = Math.floor((totalMinutes % (60 * 24)) / 60);
      const minutes = totalMinutes % 60;
      const parts = [];
      if (days > 0) parts.push(`${days}d`);
      if (hours > 0 || days > 0) parts.push(`${hours}h`);
      parts.push(`${minutes}m`);
      setActiveMembershipTimeRemaining(parts.join(" "));
    };

    computeAndSet();
    intervalId = setInterval(computeAndSet, 1000 * 30); // update every 30s

    return () => clearInterval(intervalId);
  }, [activeMembershipExpiryDate, t]);

  // eslint-disable-next-line
  const [isLoading, setIsLoading] = useState(false);

  const [playTutorialModalIsVisible, setPlayTutorialModalIsVisible] =
    useState(false);

  const togglePlayTutorialModal = () =>
    setPlayTutorialModalIsVisible((prev) => !prev);

  // Rules Q&A items (Spanish and English)
  const rulesQA_es = [
    {
      title: "¿Cómo jugar en Sport League?",
      content: `Debes enviar tus predicciones antes de la hora de cierre del evento. Una vez aceptadas y enviadas, no podrás editarlas ni cancelarlas. El objetivo principal es acumular la mayor cantidad de puntos posible, con la meta de convertirte en el campeón de tu deporte y ligas favoritas.`,
    },
    {
      title: "¿Cómo puedes ganar puntos?",
      content: `Por cada predicción acertada, puedes ganar +1, +2 o +3 puntos, dependiendo del deporte que estés jugando. Los eventos marcados con una ⭐ tendrán valor doble (x2) (el valor de puntos depende del deporte seleccionado).`,
    },
    {
      title: "¿Qué pasa si hay empate en puntos con otros usuarios?",
      content: `Si hay un empate entre dos o más usuarios al final de un torneo, el desempate se otorgará al usuario con más predicciones de ⭐ puntos. Si aún persiste el empate, el siguiente criterio será el usuario que haya ganado más CHALLENGES (Desafíos).`,
    },
    {
      title: "¿Cómo se gana un MVP?",
      content: `Para ganar un MVP deberás acertar todas las predicciones de una jornada individual o grupo de eventos. Esto te otorgará: 50, 100 o 150 tickets. (El valor dependerá de la dificultad de la liga o deporte).`,
    },
    {
      title: "¿Qué son los CHALLENGES?",
      content: `Los Challenges son competencias de eventos deportivos creadas entre dos usuarios de la misma sala o de la lista de amigos del usuario.`,
    },
    {
      title: "¿Cómo se crean los CHALLENGES?",
      content: `Los Challenges pueden crearse utilizando tus STAR COINS para apostar contra otros usuarios y determinar al ganador de un evento deportivo. El ganador puede reclamar el premio acumulado en juego, ya sea en STAR COINS o TICKETS por cada desafío realizado, y también puede ganar o perder CHAMPION POINTS, dependiendo del resultado del challenge, para seguir subiendo en la clasificación general.`,
    },
    {
      title: "Estructura de Torneos",
      content: `Existen cuatro tipos de torneos disponibles: Casual, Standard, High Stakes, y VIP Exclusive. Para participar, los jugadores deben pagar una tarifa de entrada de 300 tickets para Casual, 550 tickets para Standard, 1,100 tickets para High Stakes y 2,000 tickets para VIP Exclusive, por cada liga en la que participen. Los premios se otorgarán a los 10 mejores jugadores del ranking de cada liga al final del mes, una vez concluido el torneo. Se requiere un mínimo de 10 participantes para la distribución de premios. Si no se alcanza el mínimo, las tarifas de entrada serán reembolsadas en su totalidad a los participantes.`,
    },
    {
      title: "¿Puedo pagar la tarifa de entrada en lugar de usar mis TICKETS?",
      content: `Sí, puedes pagar el monto fijo correspondiente a cada torneo para poder unirte.`,
    },
    {
      title: "¿Cuántos TORNEOS puedo jugar gratis?",
      content: `Una cuenta gratuita permite a los usuarios participar en un máximo de dos (2) torneos Casual de cualquier liga deportiva disponible.\nLos usuarios que deseen unirse a más de dos torneos en diferentes ligas deberán:\na) Comprar tickets de membresía VIP en la tienda dentro de la aplicación, o\nb) Pagar una tarifa de entrada individual por cada torneo adicional por el que deseen ingresar.`,
    },
    {
      title: "¿Dónde puedo ver los tickets que he ganado?",
      content: `En tu billetera virtual, donde se almacenarán todos los tickets ganados por eventos acertados y desafíos ganados. Luego podrás canjearlos por increíbles recompensas en la tienda en línea (SHOP).`,
    },
    {
      title: "¿Qué puedes hacer con tus STAR COINS?",
      content: `Con tus STAR COINS puedes crear o aceptar desafíos en los TORNEOS de Sport League o RETAR A TUS AMIGOS desde tu lista de amigos.`,
    },
    {
      title:
        "¿Cuál es la cantidad mínima de STAR COINS requerida para un challenge?",
      content: `Los challenges pueden crearse con un mínimo de 100 STAR COINS.`,
    },
  ];

  const rulesQA_en = [
    {
      title: "How to play in Sport League?",
      content: `You must submit your predictions before the event's closing time. Once accepted and sent, you cannot edit or cancel your predictions. The main objective is to earn the most points possible, with the goal of becoming the champion of your favorite sport and leagues.`,
    },
    {
      title: "How can you earn points?",
      content: `For each correct prediction, you can earn +1, +2, or +3 points, depending on which sport you are playing. Events marked with a ⭐ will have double the point value (x2) (Points value depending on the sport selected).`,
    },
    {
      title: "What happens if there’s a tie in point with other users?",
      content: `If there's a tie between two or more users at the end of a tournament, the tiebreaker will go to the user with the most ⭐ points predictions. If there is still a tie after this tiebreaker, the next criterion will be the user who won more CHALLENGES.`,
    },
    {
      title: "How do you win an MVP?",
      content: `To win an MVP you will have to correctly predict all the answers for an individual matchday or group of events. That will earn you: 50, 100, or 150 tickets. (The value will be determined by league or sports difficulty)`,
    },
    {
      title: "What are CHALLENGES?",
      content: `Challenges are competitions of sporting events created between two users from the same room or from the user's friends list.`,
    },
    {
      title: "How are CHALLENGES created?",
      content: `Challenges can be created using your STAR COINS to bet against other users to determine a winner of a sporting event. The winner can choose to claim the pot prize in play, either in STAR COINS or TICKETS for each challenge made and can also win or lose CHAMPION POINTS, depending on the outcome of the challenge, to keep grinding on the tier list ranks.`,
    },
    {
      title: "Tournament Structure?",
      content: `There are four types of tournaments available: Casual, Standard, High Stakes, and VIP Exclusive. To participate, players must pay an entry fee of 300 tickets for Casual, 550 tickets for Standard, 1,100 tickets for High Stakes, and 2,000 tickets for VIP Exclusive tournaments, per league entered. Prizes will be awarded to the top 10 players on each league’s leaderboard at the end of the month, once the tournament concludes. A minimum of 10 participants is required for prize distribution. If this minimum is not met, all entry fees will be fully refunded to participants.`,
    },
    {
      title: "Can I pay the tournament entry fees instead of using my TICKETS?",
      content: `Yes, you can pay the fixed amount for each tournament to allow users to join.`,
    },
    {
      title: "How many TOURNAMENTS can I join to play for free?",
      content: `A Free Account allows users to participate in up to two (2) Casual Tournaments from any available sport league.\nUsers who wish to join more than two tournaments across different leagues must either:\na) Purchase VIP Membership tickets from the in-app shop, or\nb) Pay a single-entry fee for each additional tournament they wish to enter.`,
    },
    {
      title: "Where can I see the tickets, I won?",
      content: `In your virtual wallet, it will store all the tickets you have won from all correctly answered events and challenges won. That you can later redeem for amazing rewards in the online SHOP.`,
    },
    {
      title: "What can you do with your STAR COINS?",
      content: `With your STAR COINS, you can create or accept challenges in Sport League’s TOURNAMENTS or CHALLENGE YOUR FRIENDS from your friends list.`,
    },
    {
      title: "What is the minimum amount of STAR COINS needed for a challenge?",
      content: `Challenges can be created with a minimum of 100 STAR COINS.`,
    },
  ];

  // We'll render the Q&A using RSuite Accordion (mapped from rulesQA_es / rulesQA_en)

  const navigate = useNavigate();

  // eslint-disable-next-line
  const [leagues, setLeagues] = useState();
  const fetchUsersLeagues = async () => {
    try {
      setIsLoading(true);

      let fetchedLeagues = [];

      const q = query(
        collection(db, "rooms"),
        where("memberUids", "array-contains", user?.uid)
      );
      const docs = await getDocs(q);
      docs.forEach((doc) => {
        const newRoom = doc.data();
        if (!fetchedLeagues.some((e) => e.uid === newRoom.leagueUid)) {
          const newLeague = {
            uid: newRoom.leagueUid,
            name: newRoom.leagueName,
            origin: newRoom.leagueOrigin,
            logo: newRoom.leagueLogo,
          };
          fetchedLeagues.push(newLeague);
        }
      });

      setLeagues(fetchedLeagues);

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching user's leagues");
    }
  };

  useEffect(() => {
    if (user) {
      fetchUsersLeagues();
    }
    // eslint-disable-next-line
  }, [user]);

  const [activeCategory, setActiveCategory] = useState("YOUR LEAGUES");
  const toggleActiveCategory = (category) => {
    setActiveCategory(category);
  };

  const getActiveMembershipTierIcon = (tier) => {
    switch (tier) {
      case "platinum":
        return "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fbadges%2FMultiplicador%202x%20Platinum.png?alt=media&token=41617020-aeb0-44dc-9d4f-5c32bc47b9df";
      case "gold":
        return "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fbadges%2FMultiplicador%202x%20Gold.png?alt=media&token=90bc68dd-b55c-4ad9-bfd8-5ef9a1a9d192";
      default:
        return null;
    }
  };

  if (isLoading)
    return (
      <div className="loadingPage">
        <img
          alt="logo"
          src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Flogos%2F01%20-%20SL%20Logo%203.png?alt=media&token=2e5a6320-d2d7-45f8-9bc9-a8f9c7f8caa6"
          style={{
            width: 100,
            marginBottom: "1rem",
          }}
        />
        <BarLoader color="#005EE1" />
      </div>
    );

  return (
    <div id="playPage" className="page">
      <PlayTutorialModal
        isOpen={playTutorialModalIsVisible}
        onClose={() => setPlayTutorialModalIsVisible(false)}
      />
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <h1>{t("playNow").toUpperCase()}</h1>
          <IoIosInformationCircleOutline
            onClick={togglePlayTutorialModal}
            style={{
              marginTop: -12,
              marginLeft: 5,
              cursor: "pointer",
              color: "#005EE1",
              width: 26,
              height: 26,
            }}
          />
        </div>
        {getActiveMembershipTierIcon(activeMembershipTier) ? (
          <div
            className="playPageTicketBoostContainer"
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <img
              alt="ticketBoostIcon"
              src={getActiveMembershipTierIcon(activeMembershipTier)}
              style={{ width: 50, height: "auto" }}
            />
            {activeMembershipTimeRemaining ? (
              <p
                style={{
                  color: "#FFFFFF",
                  marginBottom: 0,
                  marginLeft: "0.75rem",
                  fontWeight: "700",
                  fontSize: "0.95rem",
                }}
              >
                {activeMembershipTimeRemaining}
              </p>
            ) : null}
            {/* <p
              style={{
                color: "#FFFFFF",
                marginBottom: 0,
                marginLeft: "-1.5rem",
                fontWeight: "bold",
              }}
            >
              {activeTicketBoostTimeRemaining}
            </p> */}
          </div>
        ) : null}
      </div>
      <div>
        <ScrollMenu>
          <div
            className={classnames("shopCategoriesMenuItem", {
              active: activeCategory === "YOUR LEAGUES",
            })}
            onClick={() => toggleActiveCategory("YOUR LEAGUES")}
          >
            <p>{t("yourLeagues").toUpperCase()}</p>
          </div>
          <div
            className={classnames("shopCategoriesMenuItem", {
              active: activeCategory === "RULES",
            })}
            onClick={() => toggleActiveCategory("RULES")}
          >
            <p>{t("rules").toUpperCase()}</p>
          </div>
        </ScrollMenu>
        {!activeCategory || activeCategory === "YOUR LEAGUES" ? (
          <div style={{ marginTop: "1rem" }}>
            <p className="playPageHeader">{t("yourLeagues").toUpperCase()}</p>
            <Button
              onClick={() => navigate("/play/join-a-league")}
              className="primaryBtn"
              style={{ marginBottom: "0.5rem" }}
            >
              {t("joinANewLeague").toUpperCase()}
            </Button>
            {leagues?.length > 0 ? (
              leagues?.map((league) => {
                return (
                  <div
                    onClick={() => navigate(`/play/leagues/${league.uid}`)}
                    className="playPageLeagueContainer"
                  >
                    <img
                      alt="leagueLogo"
                      src={
                        league.logo
                          ? league.logo
                          : "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fleagues%2FleaguePlaceholder.png?alt=media&token=91a9596c-5be9-49ec-8917-d9da4f07b702"
                      }
                      // style={{backgroundColor: 'white'}}
                    />
                    <div>
                      <p style={{ fontWeight: "bold" }}>{league.name}</p>
                      <p>{league.origin}</p>
                    </div>
                  </div>
                );
              })
            ) : (
              <p
                style={{
                  color: "#FFFFFF",
                  textAlign: "center",
                  marginTop: "1rem",
                  marginBottom: 0,
                }}
              >
                {t("youreNotInAnyLeaguesYet")}
                <br />
                {t("clickBelowToJoinYourFirst")}!
              </p>
            )}
          </div>
        ) : null}
        {!activeCategory || activeCategory === "RULES" ? (
          <div style={{ marginTop: "1rem" }} className="rulesSection">
            <p className="playPageHeader" style={{ marginBottom: "1rem" }}>
              {t("rules").toUpperCase()}
            </p>
            {/* Render rules content per current language (English default) */}
            {i18n?.language && i18n.language.startsWith("es") ? (
              <div
                style={{ color: "#FFFFFF" }}
                className="rulesSection__content"
              >
                <Accordion bordered>
                  {rulesQA_es.map((it, idx) => (
                    <Panel header={it.title} key={idx}>
                      <p style={{ margin: 0, color: "#cfd6e0" }}>
                        {it.content}
                      </p>
                    </Panel>
                  ))}
                </Accordion>

                <h4 style={{ color: "#FFFFFF" }}>Reglas Soccer</h4>
                <p>
                  Predice qué equipos ganarán cada partido de tus ligas
                  favoritas. Puedes elegir solo una de tres opciones para tu
                  respuesta final: el equipo LOCAL gana (+3 PUNTOS), el equipo
                  VISITANTE gana (+3 PUNTOS) o EMPATE (+3 PUNTOS). Si un partido
                  termina en EMPATE y seleccionaste que el equipo LOCAL gana o
                  que el equipo VISITANTE gana, cada usuario que seleccionó
                  estas respuestas recibirá UN (+1) PUNTO.
                </p>
                <p>
                  Habrá dos fases para cada liga o torneo de temporada
                  (dependiendo de la liga en juego). La primera fase estará
                  determinada por un número (X) de jornadas (la cantidad "X"
                  depende de la liga en juego) de la temporada regular de cada
                  liga. La segunda fase consiste en la misma pregunta de la fase
                  uno para cada partido (¿Quién ganará el partido?) del torneo
                  en curso, con una pregunta adicional para cada partido: ¿Cuál
                  es el resultado final del partido en los 90 minutos? - Si
                  predices correctamente el resultado final exacto y el
                  marcador, ganarás tres (+3) puntos y si predices el mismo
                  resultado, pero no el marcador exacto, ganarás uno (+1) punto
                  por cada partido. Al final de la temporada solo el 20% de los
                  usuarios superiores en la tabla de posiciones de la liga
                  ganarán una recompensa exclusiva por cada liga. Los valores de
                  los puntos permanecen iguales hasta el final de la liga/torneo
                  o temporada.
                </p>

                <h4 style={{ color: "#FFFFFF" }}>Reglas Football</h4>
                <p>
                  Predice qué equipos ganarán cada partido en tus ligas
                  favoritas. Puedes elegir solo una de dos opciones como tu
                  respuesta final: el equipo LOCAL gana (+2 PUNTOS) o el equipo
                  VISITANTE gana (+2 PUNTOS). Si un partido termina en EMPATE y
                  seleccionaste que el equipo LOCAL gana o que el equipo
                  VISITANTE gana, se otorgará UN (+1) PUNTO a todos los usuarios
                  con estas respuestas.
                </p>

                <p>
                  Habrá dos fases para jugar en la temporada. La primera fase
                  serán las jornadas de la temporada regular del torneo. La
                  segunda fase serán los partidos de los PLAYOFFS de la
                  temporada en curso. El valor de los puntos permanece igual (+2
                  puntos) hasta el final de la temporada, con una pregunta
                  adicional para cada partido: ¿Cuál será el último marcador del
                  juego, independientemente del resultado final (TOUCHDOWN,
                  FIELD GOAL o SAFETY)? Si predices correctamente esto, ganarás
                  tres (+3) puntos, totalizando cinco (+5) puntos por partido.
                </p>

                <h4 style={{ color: "#FFFFFF" }}>Reglas Baseball</h4>
                <p>
                  Predice qué equipos ganarán cada partido de la MLB. Puedes
                  elegir solo una de dos opciones como tu respuesta final: el
                  equipo LOCAL gana (+0.25 PUNTOS) o el equipo VISITANTE gana
                  (+0.25 PUNTOS). Responder correctamente a cuatro (4) partidos
                  te ganará un total de un (+1) PUNTO completo. Si predices
                  correctamente un partido con un símbolo ⭐, ganarás un (+1)
                  PUNTO completo por partido, que también se duplicará en valor
                  (x2). Si un partido termina en EMPATE o CANCELADO y
                  seleccionaste que el equipo LOCAL gana o que el equipo
                  VISITANTE gana, se otorgará un (+1) PUNTO a todos los usuarios
                  con estas respuestas.
                </p>

                <p>
                  Habrá dos fases de juego. La primera fase será el calendario
                  completo de la temporada regular. La segunda fase serán los
                  partidos de los PLAYOFFS de la temporada en curso. Los puntos
                  ganados en esta segunda fase serán un (+1) punto por cada
                  partido correctamente predicho, hasta el final de la
                  temporada, con una pregunta adicional para cada partido:
                  ¿Predice el RESULTADO FINAL del juego (Incluyendo entradas
                  extras en caso de un empate)? - donde recibirás tres puntos
                  (+3 puntos), totalizando cuatro (+4) puntos por partido.
                </p>

                <h4 style={{ color: "#FFFFFF" }}>Reglas Hockey</h4>
                <p>
                  Predice qué equipos ganarán cada partido de la NHL. Puedes
                  elegir solo una de dos opciones como tu respuesta final: el
                  equipo LOCAL gana (+0.25 PUNTOS) o el equipo VISITANTE gana
                  (+0.25 PUNTOS). Responder correctamente a 4 eventos te ganará
                  un total de un (+1) PUNTO completo. Si predices correctamente
                  un partido con un símbolo ⭐, ganarás un (+1) PUNTO completo
                  por partido, que también se duplicará en valor (x2). Si un
                  partido termina en EMPATE o CANCELADO y seleccionaste que el
                  equipo LOCAL gana o que el equipo VISITANTE gana, se otorgará
                  un (+1) PUNTO a todos los usuarios con estas respuestas.
                </p>

                <p>
                  Habrá dos fases de juego. La primera fase será el calendario
                  completo de la temporada regular. La segunda fase serán los
                  partidos de los PLAYOFFS de la temporada en curso. Los puntos
                  ganados en esta segunda fase serán un (+1) punto por cada
                  partido correctamente predicho, hasta el final de la
                  temporada, con una pregunta adicional para cada partido:
                  ¿Predice el RESULTADO FINAL del juego (Incluyendo tiempo extra
                  en caso de un empate)? - donde recibirás tres (+3) puntos,
                  totalizando cuatro (+4) puntos por partido.
                </p>

                <h4 style={{ color: "#FFFFFF" }}>Reglas Carreras</h4>
                <p>
                  Para cada ronda del GRAN PREMIO en la FORMULA 1, necesitarás
                  predecir qué pilotos terminarán en el top 3 de las carreras.
                  Si adivinas correctamente a los tres pilotos,
                  independientemente del orden, ganarás un (+1) punto por cada
                  piloto. Estos puntos tendrán el símbolo ⭐, lo que significa
                  que su valor se duplicará. Después de elegir a tus 3 pilotos,
                  deberás predecir, en cualquier orden, los siguientes pilotos
                  para las posiciones del cuarto (4º) al octavo (8º) en la
                  carrera. Cada predicción correcta te ganará un punto normal
                  (+1 punto).
                </p>

                <p>
                  Punto Extra Normal: Predice quién crees que tendrá la vuelta
                  más rápida al final de la carrera.
                </p>

                <h4 style={{ color: "#FFFFFF" }}>Reglas Baloncesto</h4>
                <p>
                  Predice qué equipos ganarán cada partido en tus ligas
                  favoritas. Puedes elegir solo una de dos opciones como tu
                  respuesta final: el equipo LOCAL gana (+2 PUNTOS) o el equipo
                  VISITANTE gana (+2 PUNTOS). Si un partido termina en EMPATE o
                  CANCELADO y seleccionaste que el equipo LOCAL gana o que el
                  equipo VISITANTE gana, se otorgará un (+1) PUNTO a todos los
                  usuarios con estas respuestas.
                </p>

                <p>
                  Habrá dos fases para jugar en la temporada. La primera fase
                  serán las jornadas de la temporada regular del torneo. La
                  segunda fase serán los partidos de los PLAYOFFS de la
                  temporada en curso. El valor de los puntos permanece igual (+2
                  puntos) hasta el final de la temporada, con una pregunta
                  adicional para cada partido: ¿Cuál será el último marcador del
                  juego, independientemente de qué equipo anotó (DOS PUNTOS,
                  TRES PUNTOS o TIRO LIBRE)? Si predices correctamente esto,
                  ganarás tres (+3) puntos, totalizando cinco (+5) puntos por
                  partido.
                </p>

                <h4 style={{ color: "#FFFFFF" }}>Reglas MMA</h4>
                <p>
                  Predice cada pelea del evento principal, eligiendo quién crees
                  que será el luchador ganador. Puedes seleccionar una de dos
                  opciones como tu respuesta final: el luchador del ESQUINA ROJA
                  gana (+2 PUNTOS) o el luchador del ESQUINA AZUL gana (+2
                  PUNTOS). Para la siguiente pregunta, necesitarás seleccionar
                  una de tres opciones: ¿Cuál será el resultado final de la
                  pelea? (+3 PUNTOS) (NOCAUT, SOMETIMIENTO o DECISIÓN DE
                  JUECES). Las peleas marcadas con una ⭐ tendrán el doble de
                  valor (x2) en puntos.
                </p>
              </div>
            ) : (
              <div
                style={{ color: "#FFFFFF" }}
                className="rulesSection__content"
              >
                <Accordion bordered>
                  {rulesQA_en.map((it, idx) => (
                    <Panel header={it.title} key={idx}>
                      <p style={{ margin: 0, color: "#cfd6e0" }}>
                        {it.content}
                      </p>
                    </Panel>
                  ))}
                </Accordion>

                <h4 style={{ color: "#FFFFFF" }}>Soccer Rules</h4>
                <p>
                  Predict which teams will win each match of your favorite
                  leagues. You can choose only one of three options for your
                  final answer: HOME team wins (+3 POINTS), AWAY team wins (+3
                  POINTS), or DRAW (+3 POINTS). If a match ends in a DRAW and
                  you select either HOME team wins or AWAY team wins, every user
                  who selected these answers will receive ONE (+1) POINT.
                </p>

                <p>
                  There will be two phases for each league or season tournament
                  (depending on the league being played). The first phase will
                  be determined by a number (X) of matchdays (quantity "X"
                  depending on the league in play) of the regular season of each
                  league. The second phase consists of the same question in
                  phase one for each match (Who will win the match?) of the
                  ongoing tournament, with an additional question for each
                  match: What is the final score of the match in the 90 minutes
                  of the match? - If you correctly predict the exact result and
                  score, you will win three (+3) points and if you predict the
                  same result, but not the exact final score, you will win one
                  (+1) point for each match. At the end of the season only the
                  top 20% users of the league’s leaderboard will win an
                  exclusive reward for each league. The points values remain the
                  same until the end of the league/tournament or season.
                </p>

                <h4 style={{ color: "#FFFFFF" }}>Football Rules</h4>
                <p>
                  Predict which teams will win each match in your favorite
                  leagues. You can choose only one of two options as your final
                  answer: HOME team wins (+2 POINTS) or AWAY team wins (+2
                  POINTS). If a match ends in a DRAW and you select either HOME
                  team wins or AWAY team wins, ONE (+1) POINT will be awarded to
                  all users with these answers.
                </p>

                <p>
                  There will be two phases to play in the season. The first
                  phase will be the regular season matchdays of the tournament.
                  The second phase will be the PLAYOFFS matches of the ongoing
                  season. The points value remains the same (+2 points) until
                  the end of the season, with an additional question for each
                  match: What will be the last score of the game, regardless of
                  the final score (TOUCHDOWN, FIELD GOAL, or SAFETY)? If you
                  correctly predict this, you will earn three (+3) points,
                  totaling five (+5) points per match. At the end of the season,
                  only the top 20% users of the league’s leaderboard will win an
                  exclusive reward for each league.
                </p>

                <h4 style={{ color: "#FFFFFF" }}>Baseball Rules</h4>
                <p>
                  Predict which teams will win each MLB match. You can choose
                  only one of two options as your final answer: HOME team wins
                  (+0.25 POINTS) or AWAY team wins (+0.25 POINTS). Answering
                  four (4) games correctly will earn you a total of one (+1)
                  full POINT. If you correctly predict a match with a ⭐ symbol,
                  you will earn one (+1) full POINT per match, which will also
                  double in value (x2). If a match ends in a DRAW or CANCELLED
                  and you selected either HOME team wins or AWAY team wins, one
                  (+1) POINT will be awarded to all users with these answers.
                </p>

                <h4 style={{ color: "#FFFFFF" }}>Hockey Rules</h4>
                <p>
                  Predict which teams will win each NHL match. You can choose
                  only one of two options as your final answer: HOME team wins
                  (+0.25 POINTS) or AWAY team wins (+0.25 POINTS). Answering 4
                  events correctly will earn you a total of one (+1) full POINT.
                  If you correctly predict a match with a ⭐ symbol, you will
                  earn one (+1) full POINT per match, which will also be doubled
                  in value (x2). If a match ends in a DRAW or CANCELLED and you
                  selected either HOME team wins or AWAY team wins, one (+1)
                  POINT will be awarded to all users with these answers.
                </p>

                <h4 style={{ color: "#FFFFFF" }}>Racing Rules</h4>
                <p>
                  For each GRAND PRIX round in FORMULA 1, you will need to
                  predict which drivers will finish in the top 3 of the races.
                  If you correctly guess all three drivers, regardless of order,
                  you will earn one (+1) point for each driver. These points
                  will have the ⭐ symbol, meaning it has double its value.
                  After choosing your top 3 drivers, you will then predict, in
                  any order, the next drivers for positions from fourth (4th) to
                  eighth (8th) in the race. Each correct prediction earns a
                  normal point (+1 point).
                </p>

                <h4 style={{ color: "#FFFFFF" }}>Basketball Rules</h4>
                <p>
                  Predict which teams will win each match in your favorite
                  leagues. You can choose only one of two options as your final
                  answer: HOME team wins (+2 POINTS) or AWAY team wins (+2
                  POINTS). If a match ends in a DRAW or CANCELLED and you
                  selected either HOME team wins or AWAY team wins, ONE (+1)
                  POINT will be awarded to all users with these answers.
                </p>

                <h4 style={{ color: "#FFFFFF" }}>MMA Rules</h4>
                <p>
                  Predict every fight of the main event, choosing who you think
                  will be the winning fighter. You can select one of two options
                  for your final answer: RED CORNER fighter wins (+2 POINTS) or
                  BLUE CORNER fighter wins (+2 POINTS). For the next question,
                  you will need to select one of three options: What will be the
                  result of the fight (+3 POINTS) (KNOCKOUT, SUBMISSION, or
                  JUDGES' DECISION). Fights marked with a ⭐ will have double
                  the value (x2) in points.
                </p>
              </div>
            )}
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default PlayPage;
